

















































import { Vue, Component, Prop } from "vue-property-decorator";

import { ADV_QUERY_FIELDS, ADV_QUERY_OPERATORS } from "@/app-data/patent-query";
import { isEmptyOrWhiteSpace } from "@/utils/Common";
import { CondItem, CondObject } from "@/types";
import { CondOperator } from "@/app-data/enum";

@Component
export default class AdvSearch extends Vue {
  @Prop({ type: String, default: () => "" })
  condition!: string;

  @Prop({ type: Array, default: () => [] })
  appendFields!: typeof ADV_QUERY_FIELDS;

  defineConds: Array<CondItem> = [];

  condRelation = "";

  initCondObjectCount = 3;

  fieldTypeMap: Map<string, typeof ADV_QUERY_FIELDS[0]> = new Map<string, typeof ADV_QUERY_FIELDS[0]>();

  created() {
    this.allFields.forEach((field: any) => this.fieldTypeMap.set(field.name, field));

    if (!isEmptyOrWhiteSpace(this.condition)) {
      const cond: CondObject = JSON.parse(this.condition);
      const conds = cond.items || [];
      conds.forEach(item => {
        const field = this.fieldTypeMap.get(item.name);
        if (!field) {
          return;
        }
        if (field.type === "date") {
          item.value1 = [item.value1, item.value2];
          item.value2 = "";
        } else if (field.type === "enum") {
          item.value1 = (item.value1 || "").split(",");
          item.value2 = "";
        } else if (field.type === "tree") {
          item.value1 = (item.value1 || "").split(",").map((value: string) => value.split("/"));
          item.value2 = "";
        }
      });
      if (conds.length < this.initCondObjectCount) {
        while (conds.length < this.initCondObjectCount) {
          conds.push({ name: "", operator: "", value1: "", value2: "" });
        }
      }
      this.defineConds = conds;
      this.condRelation = cond.relation || "";
    } else {
      for (let i = 0; i < this.initCondObjectCount; i++) {
        this.defineConds.push({ name: "", operator: "", value1: "", value2: "" });
      }
    }
  }

  get allFields() {
    const defFields: typeof ADV_QUERY_FIELDS = JSON.parse(JSON.stringify(ADV_QUERY_FIELDS));
    if (this.appendFields && this.appendFields.length) {
      defFields.push(...JSON.parse(JSON.stringify(this.appendFields)));
    }
    return defFields;
  }

  get groupedFields() {
    const fields = this.allFields;
    const groups: Array<{ name: string, fields: typeof ADV_QUERY_FIELDS }> = [];
    const map = new Map<string, typeof ADV_QUERY_FIELDS>();
    fields.forEach(field => {
      const group = field.group || "字段";
      if (!map.has(group)) {
        map.set(group, []);
      }
      const fields = map.get(group);
      if (fields) {
        fields.push(field);
      }
    });
    map.forEach((value, key) => groups.push({ name: key, fields: value }));
    return groups;
  }

  get condOpers() {
    return CondOperator;
  }

  getCondOperators(fieldName: string) {
    if (isEmptyOrWhiteSpace(fieldName)) {
      return [];
    }
    const item = this.fieldTypeMap.get(fieldName);
    if (!item) {
      return [];
    }
    return (ADV_QUERY_OPERATORS as any)[item.type];
  }

  getFieldType(fieldName: string) {
    const item = this.fieldTypeMap.get(fieldName);
    return item ? item.type : "";
  }

  getEnumData(fieldName: string) {
    const item = this.fieldTypeMap.get(fieldName);
    if (!item) {
      return [];
    }
    if (!isEmptyOrWhiteSpace(item.enumKey)) {
      return this.$store.getters["enums/getEnumsByKey"](item.enumKey).map((item: any) => [item.label, item.enumValue]);
    }
    if (item.enumValues) {
      return item.enumValues.map(value => [value, value]);
    }
    return [];
  }

  getTreeData(fieldName: string) {
    const item = this.fieldTypeMap.get(fieldName);
    if (!item) {
      return [];
    }
    return item.treeData || [];
  }

  addRow() {
    this.defineConds.push({ name: "", operator: "", value1: "", value2: "" });
  }

  deleteRow() {
    if (this.defineConds.length > 3) {
      this.defineConds.pop();
    }
  }

  onFieldChange(cond: CondItem) {
    cond.value1 = "";
    cond.value2 = "";
    cond.operator = "";
    if (!isEmptyOrWhiteSpace(cond.name)) {
      const opers = this.getCondOperators(cond.name);
      if (opers.length) {
        cond.operator = opers[0][0];
      }
    }
    this.execCondRelation();
  }

  onOperatorChange(cond: CondItem) {
    cond.value1 = "";
    cond.value2 = "";
  }

  validateCond() {
    return true;
  }

  getSearchData() {
    if (!this.validateCond()) {
      return null;
    }
    const cond: CondObject = { items: [], relation: "" };
    if (!this.defineConds.length) {
      return cond;
    }
    cond.relation = this.condRelation;
    const defs: Array<CondItem> = JSON.parse(JSON.stringify(this.defineConds));
    defs.forEach((item) => {
      if (isEmptyOrWhiteSpace(item.name)) {
        return;
      }
      if (isEmptyOrWhiteSpace(item.operator)) {
        if (item.value1 instanceof Array) {
          item.operator = CondOperator.BETWEEN;
        } else {
          item.operator = CondOperator.GT;
        }
      }
      if (item.value1 instanceof Array) {
        const field = this.fieldTypeMap.get(item.name);
        if (!field) {
          return;
        }
        const arr = item.value1;
        if (field.type === "date") {
          item.value1 = arr[0];
          item.value2 = arr[1];
        } else if (field.type === "enum") {
          item.value1 = item.value1.join(",");
        } else if (field.type === "tree") {
          item.value1 = item.value1.map(data => data.join("/")).join(",");
        }
      }
      cond.items.push(item);
    });
    return JSON.stringify(cond);
  }

  execCondRelation() {
    const condArr: Array<string> = [];
    this.defineConds.forEach((cond, index) => {
      if (!cond || isEmptyOrWhiteSpace(cond.name)) {
        return;
      }
      condArr.push((index + 1).toString());
    });
    this.condRelation = condArr.join(" and ");
  }
}
